<template>
  <splitpanes class="default-theme">
    <pane min-size="10" size="15">
      <div class="card-header" style="width: 100%;border: solid 1px lightgrey">
        <span style="margin: 5px;font-weight: bold">定义目录</span>
        <el-icon :size="24" @click="refreshNode(currentDir.id)" style="margin-top: 5px">
          <ElIconRefresh class="el-icon-refresh"/>
        </el-icon>
      </div>

      <el-tree
          ref="tree"
          :data="dirData"
          :props="defaultProps"
          node-key="id"
          :load="loadNode"
          lazy
          @node-click="nodeClickHandle"
          highlight-current
          :expand-on-click-node="false"
          min-height="500px"
          style="height: calc(100% - 40px);overflow: auto"
          >
      </el-tree>
    </pane>

    <pane min-size="50" style="background-color: white">
      <div class="card-header" style="width: 100%;padding: 3px;border: solid 1px lightgrey;background-color: whitesmoke">
        <el-row style="width: 100%">
          <el-col :span="20">
            <span width="100%" class="department-name">{{ currentDir.full_path }}</span>
          </el-col>
        </el-row>
      </div>

      <div style="background-color: white;height: calc(100% - 40px);overflow: auto">
        <frame-query
            ref="frameQuery"
            componentParam="sys_define_version"
            :parent-data="queryParam"
        ></frame-query>
      </div>
    </pane>

  </splitpanes>
</template>

<script>

import {Pane, Splitpanes} from 'splitpanes'
import 'splitpanes/dist/splitpanes.css'

export default {
  name: "SysDefineVersion",
  components: {Splitpanes, Pane},
  computed: {
    queryParam() {
      return {
        dir_id: this.currentDir.id,
        form_fixed:true
      }
    }
  },
  data() {
    return {
      dirData: [],
      currentDir: {},
      editData: {},
      defaultProps: {
        children: 'children',
        label: 'name',
        isLeaf: 'leaf',
      },
      loading: false
    }
  },
  methods: {
    refreshNode(nodeId){
      if(nodeId && nodeId.length > 0){
        this.$refs.tree.store.nodesMap[this.currentDir.id].loaded = false;
        this.$refs.tree.store.nodesMap[this.currentDir.id].loadData();
      }else{
        this.loadDirTree()
      }
    },
    //--勾选--
    nodeClickHandle(currentRow) {
      this.currentDir = currentRow
      this.currentPage = 1
      this.$refs.frameQuery.search();
    },
    async loadDirTree() {
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'sys_define', parent_id: ''})
      this.dirData = data;
    },
    async loadNode(node, resolve) {
      console.log("node.id=" + node.data.id);
      let data = await this.$http('sysDirService.getChildren', {dir_def_id: 'sys_define', parent_id: node.data.id})
      resolve(data)
    }
  },
  created() {

  }
}
</script>


<style lang="less" scoped>
@import '@/global.less';

.myContainer {
  padding: 5px;
}

.dirButtons {
  display: inline-flex;
}

.card-header {
  display: inline-flex;
  height: 36px;
}

.department-name {
  font-size: @fontSizeX;
}


.activeButton {
  background-color: #409EFF;
  color: #FFFFFF
}

.scroller::-webkit-scrollbar {
  width: 3px;
}

.scroller::-webkit-scrollbar-track {
  background-color: transparent;
}

.scroller::-webkit-scrollbar-thumb {
  background-color: #C1C1C1;
}

.departmentBody {
  border: #ececec solid 1px;
  font-weight: normal;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  height: 100%;
  width: 100%;
  padding: 0 1px 2px;
}

.departmentLeft {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  box-sizing: content-box;
}

.departmentRight {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: auto;
  width: 100%;
  min-width: 550px;
}

.LeftBody {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  width: 300px;
  padding-top: 10px;
  overflow-y: auto;
}

.flexRow {
  display: flex;
  flex-direction: row;
  width: 100%;
}

.userRights {
  display: flex;
  flex-direction: column;
  height: 100%;
  margin: 5px 5px 0 5px;
}

.departmentUserList {
  padding: 0 20px 10px;
  display: flex;
  flex-direction: column;
}


.titleFlex {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
}

.departmentEdit {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  margin: 10px 0;
}

.departmentTable {
  border: none;
  width: 100%;
}

.flexRow > .el-menu-item {
  height: 50px;
  line-height: 50px;
}

.buttonGroup {
  margin-left: auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}

.addButton {
  margin-left: 5px !important;
  padding: 9px;
}

.addDepartment {
  width: 140px;
  margin-right: 5px;
}

.LeftBody ::v-deep(.el-tree-node__expand-icon) {
  width: 15px;
}

.buttonGroup ::v-deep(.el-icon-key) {
  transform: rotate(180deg);
}

.editButton {
  color: lightgrey;
  min-height: 30px;
  padding: 0;
}

.editButton:hover {
  color: #00afff;
}


</style>
